import { Injectable } from "@angular/core";
import { Http, Headers, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { environment } from "../../environments/environment";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import { Router } from "@angular/router";
import { GlobalService } from "./global.service";

@Injectable()
export class ManualSuperAdminService {
  constructor(private http: Http, private router: Router) { }

  // list of distrubuter
  public listAllDistributer() {
    console.log("inside services");
    return this.http
      .get(environment.baseUrl + "/user/seller", GlobalService.getHeaders())
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      })
      .catch((error) => {
        console.log("error", error);
        if (error.status === 500) {
          console.log("status", error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log("status", err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log("status", error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log("status", err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log("status", error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log("status", err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  // list of distrubuter
  public listBankerDistributer() {
    console.log("inside services");
    return this.http
      .get(
        environment.baseUrl + "/admin/get_map_list",
        GlobalService.getHeaders()
      )
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      })
      .catch((error) => {
        console.log("error", error);
        if (error.status === 500) {
          console.log("status", error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log("status", err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log("status", error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log("status", err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log("status", error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log("status", err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  // list of banks
  public listAllBanks() {
    console.log("inside services");
    return this.http
      .get(environment.baseUrl + "/user/list_of_banks")
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      })
      .catch((error) => {
        console.log("error", error);
        if (error.status === 500) {
          console.log("status", error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log("status", err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log("status", error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log("status", err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log("status", error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log("status", err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  // discount list

  public discountList(customerId) {
    const data = {
      lenderId: customerId,
      manual_invoice: true
    };
    console.log("data", data);
    const body = JSON.stringify(data);
    console.log(body);
    return this.http
      .post(
        environment.baseUrl + "/admin/invoiceDiscountList",
        body,
        GlobalService.getHeaders()
      )
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      })
      .catch((error) => {
        console.log("error", error);
        if (error.status === 500) {
          console.log("status", error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log("status", err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log("status", error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log("status", err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log("status", error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log("status", err.responseStatus);
          return Observable.throw(err);
        }
      });
  }
}
